import React from 'react';
import { AppButton, Box } from '@common-fe/common-fe';

import { ResumeHeader } from './ResumeHeader';
import { ResumeNextSteps } from './ResumeNextSteps';
import { useEmployerReactivationResume } from './hooks/useEmployerReactivationResume';

export const EmployerReactivationResume = () => {
  const { employerName, handleGotIt } = useEmployerReactivationResume();

  return (
    <Box data-testid="EmployerReactivationResume">
      <ResumeHeader employerName={employerName} testId="EmployerReactivationResume_header" />

      <ResumeNextSteps testId="EmployerReactivationResume_next-steps" />

      <Box align="center" margin={{ bottom: 'spacing24' }}>
        <AppButton
          testId="EmployerReactivationResume_got-it"
          type="button"
          onClick={handleGotIt}
          width="200px"
        >
          Got it!
        </AppButton>
      </Box>
    </Box>
  );
};
